import {
  Bell,
  BookOpen,
  Boxes,
  Building,
  Building2,
  CalendarClock,
  CircleDashed,
  FileChartColumn,
  Flag,
  Gauge,
  House,
  Kanban,
  Layers,
  LayoutDashboard,
  List,
  type LucideIcon,
  Mail,
  Radar,
  ScrollText,
  ShieldCheck,
  SlidersHorizontal,
  Sparkles,
  Sun,
  Target,
  Upload,
  Users,
  Workflow,
} from 'lucide-react';

/** Lucide icons addressable by the kebab-case names used in module manifests / navigation. */
export const NAV_ICONS: Readonly<Record<string, LucideIcon>> = {
  users: Users,
  'building-2': Building2,
  'scroll-text': ScrollText,
  'shield-check': ShieldCheck,
  sun: Sun,
  kanban: Kanban,
  building: Building,
  upload: Upload,
  'sliders-horizontal': SlidersHorizontal,
  target: Target,
  'book-open': BookOpen,
  'layout-dashboard': LayoutDashboard,
  bell: Bell,
  workflow: Workflow,
  mail: Mail,
  gauge: Gauge,
  'file-bar-chart': FileChartColumn,
  'file-chart-column': FileChartColumn,
  sparkles: Sparkles,
  radar: Radar,
  layers: Layers,
  boxes: Boxes,
  home: House,
  'calendar-clock': CalendarClock,
  house: House,
  flag: Flag,
  list: List,
};

export const FALLBACK_NAV_ICON: LucideIcon = CircleDashed;

/** Resolves a kebab-case lucide name (case/whitespace tolerant) to a component, with a fallback. */
export function resolveNavIcon(name: string | null | undefined): LucideIcon {
  if (!name) return FALLBACK_NAV_ICON;
  const key = name.trim().toLowerCase();
  return Object.hasOwn(NAV_ICONS, key) ? (NAV_ICONS[key] ?? FALLBACK_NAV_ICON) : FALLBACK_NAV_ICON;
}
